<template>
    <div v-shortkey="['esc']" @shortkey="showModal = false" @keyup.up="up()" @keyup.down="down()" @keyup.enter="enter()">
        <div class="input-group input-group-md">
            <input :class="{ 'has-danger': $props.showTextDangerMarcador }" type="text" class="form-control" :disabled="true" :value="$props.nomeMarcadorRecuperado ? $props.nomeMarcadorRecuperado : marcadorSelecionado.nome" />
            <span class="input-group-btn">
                <button ref="btnBuscarMarcador" v-shortkey="['alt', '2']" @shortkey="(showModal = true), focoNomeMarcador()" :class="{ 'btn-danger': $props.showTextDangerMarcador, 'btn-default': !$props.showTextDangerMarcador }" type="button" @click="(showModal = true), focoNomeMarcador()" class="btn btn-flat"><i class="fa fa-search"></i></button>
                <button ref="btnBuscarLimpar" :class="{ 'btn-danger': $props.showTextDangerMarcador, 'btn-default': !$props.showTextDangerMarcador }" type="button" @click="limpar()" class="btn btn-flat"><i class="fa fa-trash-o"></i></button>
            </span>
        </div>
        <transition name="modal">
            <div class="modal-mask" v-show="showModal">
                <div class="modal-container">
                    <div class="modal-header">
                        <h3>Selecionar Marcador</h3>
                    </div>
                    <div class="modal-body">
                         <div class="row">
                            <div class="col-sm-5">
                                <div class="form-group">
                                    <label for="">Nome do Marcador</label>
                                    <input ref="inputMarcador" title="[ ctrl + b ] Para pesquisar" type="text" class="form-control" v-model="filtros.name" />
                                </div>
                            </div>
                            <div class="col-sm-5">
                                <div class="form-group">
                                    <label for="">Login do Marcador</label>
                                    <input type="text" class="form-control" v-model="filtros.login" />
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="">&nbsp;</label>
                                    <button @click="getDataTable()" v-shortkey="['ctrl', 'b']" @shortkey="getDataTable()" title="[ ctrl + b ] Para pesquisar" class="btn btn-default btn-block"><span class="fa fa-filter"></span> Filtrar</button>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row" v-if="loading">
                            <div class="col-sm-12" style="text-align: center; margin-top:30px;">
                                <br />
                                <span style="text-align: center">Aguarde, processando...</span>
                            </div>
                        </div>

                        <div class="row" style="margin-top:15px" v-else>
                            <div class="col-sm-12 table-responsive">
                                <table role="grid" class="table table-bordered table-striped">
                                    <thead>
                                        <tr role="row">
                                            <th style="width: 10%">ID</th>
                                            <th style="width: auto">Nome</th>
                                            <!-- <th style="width: auto">Login</th> -->
                                         </tr>
                                    </thead>
                                    <tbody>
                                        <tr @click="seleciona(item)" :class="{ ativa: index === marcadorSelecionadoIndex }" class="even hand" role="row" v-for="(item, index) in dataTable.data" :key="index">
                                            <td>{{ item.id }}</td>
                                            <td>{{ item.name }}</td>
                                            <!-- <td>{{ item.login }}</td> -->
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-sm-5">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                                    <div class="col-sm-7" style="text-align:right">
                                        <laravue-pagination :limit="5" :data="dataTable" v-on:pagination-change-page="getDataTable">
                                            <span slot="prev-nav">&lt; Anterior</span>
                                            <span slot="next-nav">Próximo &gt;</span>
                                        </laravue-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="text-right" style="float:right">
                            <button type="button" ref="btnMarcador" class="btn btn-default" @click="showModal = false"><i class="fa fa-close"></i> Fechar</button>
                        </div>
                    </div>
                </div>

            </div>
        </transition>
    </div>
</template>

<script>
import axios from "axios"; // Cliente para requisição http

import { mask } from "vue-the-mask";
export default {
    props: ["regulador", "nomeMarcador", "showTextDangerMarcador", "cidadeUnidadeSolicitante", "nomeMarcadorRecuperado", "unidadeSolicitante"],
    components: {
        
    },
    directives: {
        mask
    },
    data: () => ({
        showFormAddMarcador: false,
        loading: false,
        marcadorSelecionadoIndex: 0,
        marcadorSelecionado: {
            nome: null
        },
        filtros: {
            nome: "",
            login: "",
        },
        showModal: false,
        dataTable: {
            data: []
        }
    }),
    mounted() {
        // this.getDataTable();
        this.marcadorSelecionadoIndex = 0;
    },
    methods: {
        getDataTable(page) {
            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.filtros.cidadeUnidadeSolicitante = this.$props.cidadeUnidadeSolicitante;
            this.filtros.unidadeSolicitante = this.$props.unidadeSolicitante;
            this.$store.commit("TOGGLE_LOADING");

            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            axios
                .get(`${this.$store.state.serverURI}/api/usuario/getAllPaginate`, config)
                .then(response => {
                    this.dataTable = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    console.log(error);
                });
        },
        limpar() {
            this.seleciona({
                id: null,
                nome: "",
                login: ""
            });
            this.$emit("limpar");
        },
        seleciona(item) {
            this.marcadorSelecionado = item;
            this.showModal = false;
            this.$emit("setMarcadorSelecionado", item);
        },
        focus() {
            this.$refs.btnBuscarMarcador.focus();
        },
        abrirModal() {
            this.$refs.btnBuscarMarcador.click();
        },
        focoNomeMarcador() {
            this.$nextTick(function() {
                this.$refs.inputMarcador.focus();
            });
        },
        up() {
            if (this.marcadorSelecionadoIndex > 0) {
                this.marcadorSelecionadoIndex--;
            }
        },
        down() {
            if (this.marcadorSelecionadoIndex < this.dataTable.data.length - 1) {
                this.marcadorSelecionadoIndex++;
            }
        },
        enter() {
            if (!this.showFormAddMarcador) {
                if (this.dataTable.data[this.marcadorSelecionadoIndex]) {
                    this.seleciona(this.dataTable.data[this.marcadorSelecionadoIndex]);
                }
            }
        }
    },
    watch: {
        "$props.nomeMarcador": function(value) {
            if (value) {
                this.marcadorSelecionado.nome = value;
            }
        },
    }
};
</script>

<style scoped>
* {
    box-sizing: border-box;
}

table {
    font-size: 12px;
}

.modal-mask {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
}

.modal-container {
    width: 90%;
    margin: 40px auto 0;
    padding: 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
    margin-top: 0;
    color: #333;
}

.modal-body {
    margin: 10px 0;
}

.text-right {
    text-align: right;
}

.form-label {
    display: block;
    margin-bottom: 1em;
}

.form-label > .form-control {
    margin-top: 0.5em;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
}

/*
			 * The following styles are auto-applied to elements with
			 * transition="modal" when their visibility is toggled
			 * by Vue.js.
			 *
			 * You can easily play with the modal transition by editing
			 * these styles.
			 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.modal {
    display: block !important;
    /* I added this to see the modal, you don't need this */
}

/* Important part */

.modal-dialog {
    overflow-y: initial !important;
}

.modal-body {
    height: 350px;
    overflow-y: auto;
}

.has-danger {
    border-color: #d73925;
}
</style>



// WEBPACK FOOTER //
// selectMarcador.vue?722fb607